import styled from 'styled-components';

export const SReactSpinePlayer = styled.div`
  position: absolute;
  background-size: contain;
  width: 360px;
  height: 240px;
  top: -2px;
  z-index: 2;
  pointer-events: none;

  @media (max-width: 990px) and (max-aspect-ratio: 1/1) {
    top: -22px;
  }

  @media (max-width: 600px) and (max-aspect-ratio: 1/1) {
    width: 320px;
    height: 210px;
    top: -22px;
  }

  @media (max-width: 500px) and (max-aspect-ratio: 1/1) {
    width: 290px;
    height: 195px;
    top: -10px;
  }

  @media (max-width: 450px) and (max-aspect-ratio: 1/1) {
    width: 230px;
    height: 150px;
    top: -9px;
  }

  @media (max-width: 360px) and (max-aspect-ratio: 1/1) {
    width: 200px;
    height: 130px;
    top: 5px;
  }
`;

/*
@media (max-width: 990px) and (max-aspect-ratio: 1/1) {
  height: 234px;
}

@media (max-width: 600px) and (max-aspect-ratio: 1/1) {
  top: 1px;
}

@media (max-width: 590px) and (max-aspect-ratio: 1/1) {
  top: 2px;
}

@media (max-width: 580px) and (max-aspect-ratio: 1/1) {
  height: 210px;
  width: 460px;
  top: -15px;
}

@media (max-width: 575px) and (max-aspect-ratio: 1/1) {
  top: -14px;
}

@media (max-width: 570px) and (max-aspect-ratio: 1/1) {
  top: -13px;
}

@media (max-width: 560px) and (max-aspect-ratio: 1/1) {
  top: -12px;
}

@media (max-width: 550px) and (max-aspect-ratio: 1/1) {
  top: -11px;
}

@media (max-width: 540px) and (max-aspect-ratio: 1/1) {
  top: -10px;
}

@media (max-width: 529px) and (max-aspect-ratio: 1/1) {
  top: -9px;
}

@media (max-width: 520px) and (max-aspect-ratio: 1/1) {
  top: -8px;
}

@media (max-width: 510px) and (max-aspect-ratio: 1/1) {
  top: -7px;
}

@media (max-width: 500px) and (max-aspect-ratio: 1/1) {
  top: -6px;
}

@media (max-width: 490px) and (max-aspect-ratio: 1/1) {
  top: -5px;
}

@media (max-width: 480px) and (max-aspect-ratio: 1/1) {
  height: 170px;
  width: 400px;
  top: -6px;
}

@media (max-width: 470px) and (max-aspect-ratio: 1/1) {
  top: -5px;
}

@media (max-width: 460px) and (max-aspect-ratio: 1/1) {
  top: -3px;
}

@media (max-width: 450px) and (max-aspect-ratio: 1/1) {
  height: 150px;
  width: 390px;
  top: -5px;
}

@media (max-width: 440px) and (max-aspect-ratio: 1/1) {
  top: -4px;
}

@media (max-width: 430px) and (max-aspect-ratio: 1/1) {
  top: -3px;
}

@media (max-width: 420px) and (max-aspect-ratio: 1/1) {
  top: -2px;
}

@media (max-width: 410px) and (max-aspect-ratio: 1/1) {
  top: -1px;
}

@media (max-width: 402px) and (max-aspect-ratio: 1/1) {
  top: 0px;
}

@media (max-width: 390px) and (max-aspect-ratio: 1/1) {
  top: 2px;
}

@media (max-width: 380px) and (max-aspect-ratio: 1/1) {
  top: 3px;
}

@media (max-width: 370px) and (max-aspect-ratio: 1/1) {
  height: 140px;
  width: 350px;
  top: 10px;
}

@media (max-width: 365px) and (max-aspect-ratio: 1/1) {
  top: 12px;
}

@media (max-width: 345px) and (max-aspect-ratio: 1/1) {
  height: 130px;
  width: 330px;
  top: 19px;
}

@media (max-width: 340px) and (max-aspect-ratio: 1/1) {
  top: 20px;
}

@media (max-width: 330px) and (max-aspect-ratio: 1/1) {
  top: 21px;
}

@media (max-width: 320px) and (max-aspect-ratio: 1/1) {
  top: 22px;
}

@media (max-width: 310px) and (max-aspect-ratio: 1/1) {
  top: 23px;
}

@media (max-width: 300px) and (max-aspect-ratio: 1/1) {
  height: 110px;
  width: 310px;
  top: 22px;
}

@media (max-width: 290px) and (max-aspect-ratio: 1/1) {
  top: 23px;
}

@media (max-width: 280px) and (max-aspect-ratio: 1/1) {
  top: 24px;
}

@media (max-width: 270px) and (max-aspect-ratio: 1/1) {
  top: 25px;
}

@media (max-width: 260px) and (max-aspect-ratio: 1/1) {
  top: 26px;
}

@media (max-width: 250px) and (max-aspect-ratio: 1/1) {
  top: 28px;
}
*/
